export const annotationTypes = ["tag", "sheet", "user"];
